export const SERVICE_NEGOTIATION_CANCELLED_STATUS_NAMES = [
  "Cancelled",
  "Service Negotiation Cancelled",
];

export const SERVICE_NEGOTIATION_FINALIZED_STATUS_NAMES = [
  "Finished",
  "Ignored",
  "Lost",
  "Rejected By Vendor",
  "Rejected Offer",
  "Won Service Quotation",
];

export const SERVICE_NEGOTIATION_COMPLETED_STATUS_NAMES = [
  ...SERVICE_NEGOTIATION_FINALIZED_STATUS_NAMES,
  ...SERVICE_NEGOTIATION_CANCELLED_STATUS_NAMES,
];
